import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private spinner: NgxSpinnerService) { }

  success(mensagem: string, toast: boolean = false, tempo: number = 3000) {
    return Swal.fire({
      type: 'success',
      title: 'Sucesso!',
      text: mensagem,
      timer: tempo,
      showCancelButton: false,
      showConfirmButton: true,
      toast: toast
    });
  }

  warning(mensagem: string, toast: boolean = false, textNegativo: string = 'Não', textPositivo: string = 'Sim') {
    return Swal.fire({
      type: 'warning',
      title: 'Atenção!',
      text: mensagem,
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: textNegativo,
      confirmButtonText: textPositivo,
      toast: toast
    });
  }

  error(message: any, status = 0) {
    if (message.error)
      message = message.error;

    this.spinner.hide();
    switch (status) {
      case 304:
        return Swal.fire({
          showConfirmButton: false,
          title: 'Sem alterações!',
          text: 'Nenhuma alteração realizada.',
          timer: 2000,
          type: 'warning'
        });
      case 403:
        return Swal.fire({
          showConfirmButton: false,
          title: 'Não autorizado!',
          text: 'A ação não foi autorizada pelo sistema.',
          timer: 2000,
          type: 'warning'
        });
      case 404:
        return Swal.fire({
          showConfirmButton: false,
          title: 'Não encontrado!',
          text: 'O dado solicitado não foi encontrado.',
          timer: 2000,
          type: 'error'
        });
      case 405:
        return Swal.fire({
          showConfirmButton: false,
          title: 'Falha!',
          text: 'Método não disponível.',
          timer: 2000,
          type: 'error'
        });
      case 500:
        return Swal.fire({
          showConfirmButton: true,
          title: 'Erro!',
          text: 'Ocorreu um erro interno, tente novamente mais tarde! Se a falha persistir, entre em contato com o suporte técnico.',
          type: 'error'
        });
      default:
        return Swal.fire({
          showConfirmButton: true,
          title: 'Erro!',
          text: message,
          type: 'error'
        });
    }
  }

  info(mensagem: string, toast: boolean = false) {
    return Swal.fire({
      type: 'info',
      title: 'Atenção!',
      text: mensagem,
      showCancelButton: false,
      showConfirmButton: true,
      toast: toast
    });
  }

  question(titulo: string, mensagem: string, textNegativo: string = 'Não', textPositivo: string = 'Sim') {
    return Swal.fire({
      type: 'question',
      title: titulo,
      text: mensagem,
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: textNegativo,
      confirmButtonText: textPositivo
    });
  }
}
